import { render } from "./QuestionDetail.vue?vue&type=template&id=46820af4&scoped=true"
import script from "./QuestionDetail.vue?vue&type=script&lang=js"
export * from "./QuestionDetail.vue?vue&type=script&lang=js"

import "./QuestionDetail.vue?vue&type=style&index=0&id=46820af4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46820af4"]])

export default __exports__